import * as React from "react";
import { matchPath, useLocation } from "react-router-dom";
import { NotFoundPage } from "@/containers/NotFoundPage";
import { BackgroundLibraryPage } from "@/containers/Admin/Backgrounds/BackgroundLibraryPage";
import { DesignEditorPage, NewDesignPage, DesignStudioListPage } from "@/containers/Coach/DesignStudio";
import { DesignStudioScopeProvider } from "@/containers/Coach/DesignStudio/DesignStudioScope";
import { URLS } from "@/utils/routes";
import { useSocialCoachSession } from "@/utils/useSocialCoachSession";

export * from "@/containers/Coach/DesignStudio/DesignStudioScope";

function pageForPath(pathname: string): React.FC {
  // Before the editor: "/admin/design-studio/backgrounds" would otherwise read as a package id.
  if (matchPath(pathname, { path: URLS.admin.designStudioBackgrounds, exact: true })) return BackgroundLibraryPage;
  if (matchPath(pathname, { path: URLS.admin.adminNewDesign, exact: true })) return NewDesignPage;
  if (matchPath(pathname, { path: URLS.admin.adminDesign, exact: true })) return DesignEditorPage;
  return DesignStudioListPage;
}

/** Wraps the Design Studio pages (and the admin-only background library) in the admin scope; non-admins get the 404 page. */
export const AdminDesignStudio: React.FC = () => {
  const { isAdmin } = useSocialCoachSession();
  const location = useLocation();

  if (!isAdmin) return <NotFoundPage />;

  const Page = pageForPath(location.pathname);
  return (
    <DesignStudioScopeProvider>
      <Page />
    </DesignStudioScopeProvider>
  );
};
